// Ficha del ticket: resumen siempre visible y detalle desplegable
// ============
import React, { useState } from 'react';
import classes from './DetalleEncuesta.css';
import { formatFechaDD_MM_YYYY } from '../../../shared/fechas';

const DetalleEncuesta = ({ numeroEncuesta, fechaSolicitud, fechaCierre, cliente, SolicitadaPor, RealizadaPor, Tema }) => {
  const [abierto, setAbierto] = useState(false);

  return (
    <div className={classes.ficha}>
      <div className={classes.resumen}>
        <div className={classes.que}>
          <span className={classes.tarea}>{Tema}</span>
          <span className={classes.meta}>
            Atendido por <b>{RealizadaPor}</b> · {formatFechaDD_MM_YYYY(fechaCierre)}
          </span>
        </div>
        <button
          type="button"
          className={classes.toggle}
          aria-expanded={abierto}
          aria-controls="detalleEncuesta"
          onClick={() => setAbierto((prev) => !prev)}
        >
          {abierto ? 'Ocultar detalle' : 'Ver detalle'}
        </button>
      </div>
      {abierto && (
        <div className={classes.detalle} id="detalleEncuesta">
          <div>
            <span className={classes.k}>Ticket</span>
            <span className={classes.v}>#{numeroEncuesta}</span>
          </div>
          <div>
            <span className={classes.k}>Cliente</span>
            <span className={classes.v}>{cliente}</span>
          </div>
          <div>
            <span className={classes.k}>Solicitado por</span>
            <span className={classes.v}>{SolicitadaPor}</span>
          </div>
          <div>
            <span className={classes.k}>Solicitado el</span>
            <span className={classes.v}>{formatFechaDD_MM_YYYY(fechaSolicitud)}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default DetalleEncuesta;
